(function () {
  'use strict';
  if (window.__tiCareerReturn) return;
  window.__tiCareerReturn = true;
  const key = 'tiCareerReturn.v1';
  const allowed = path => /^\/(?:pages\/[^/]+|blogs\/ships-and-vehicles\/[^/]+|collections\/[^/]+(?:\/products\/[^/]+)?|products\/[^/]+)\/?$/.test(path);
  const localUrl = value => { try { const url = new URL(value, location.origin); return url.origin === location.origin && !url.username && !url.password && allowed(url.pathname) ? url : null; } catch { return null; } };
  let context;
  try {
    const saved = JSON.parse(sessionStorage.getItem(key));
    const destination = localUrl(saved?.destination), back = localUrl(saved?.back);
    if (saved?.v === 1 && destination?.pathname === location.pathname && back && saved.created > Date.now() - 4 * 60 * 60 * 1000 && saved.created <= Date.now() && typeof saved.label === 'string' && saved.label.length < 160 && typeof saved.note === 'string' && saved.note.length < 400) context = saved;
  } catch { /* Storage is optional; all links still work without it. */ }
  const save = value => { try { sessionStorage.setItem(key, JSON.stringify(value)); } catch {} };
  function mount() {
    const guide = document.querySelector('[data-ship-career-guide]');
    if (context && !guide) {
      const main = document.querySelector('main,[role="main"]');
      if (main && !document.querySelector('[data-career-return]')) {
        const aside = document.createElement('aside');
        aside.className = 'ti-career-return'; aside.dataset.careerReturn = '';
        aside.setAttribute('aria-label', 'Your career guide choice');
        const link = document.createElement('a'); link.href = context.back; link.textContent = 'Back to career recommendations';
        const label = document.createElement('strong'); label.textContent = context.label;
        const note = document.createElement('span'); note.textContent = context.note;
        aside.append(link, label, note); main.prepend(aside);
      }
    }
    document.addEventListener('click', event => {
      const link = event.target.closest('a[href]');
      if (!link || link.closest('[data-career-return]')) return;
      const destination = localUrl(link.href);
      if (!destination || destination.pathname === location.pathname) return;
      const source = link.closest('[data-ship-career-guide]');
      if (source) {
        const chapter = link.closest('[data-chapter]');
        const pick = link.closest('[data-ship]');
        const back = new URL(location.href);
        if (pick?.id || chapter?.id) back.hash = pick?.id || chapter.id;
        if (!localUrl(back.href)) return;
        const branch = chapter?.querySelector('[data-branch-choice][aria-pressed="true"]')?.textContent.trim();
        const heading = chapter?.querySelector('h2')?.textContent.trim() || 'Career ship guide';
        const note = link.hasAttribute('data-matrix-state') ? 'Compare the shortlist, then return to the career advice at any time.' : "Check which variant you're buying and what equipment is included.";
        context = { v: 1, destination: destination.href, back: back.href, created: Date.now(), label: (pick?.dataset.ship || branch || heading).slice(0, 159), note };
        save(context);
      } else if (context && /^\/(?:collections|products|blogs\/ships-and-vehicles)\//.test(destination.pathname)) {
        save({ ...context, destination: destination.href });
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true });
  else mount();
})();
